<div class="spinner" [style.width.px]="size" [style.height.px]="size" [style.borderWidth.px]="thickness"></div>
